<template>
  <v-card class="main-card">
    <v-card-title text-color="#15336d">
        <v-icon left color="#15336d">mdi-label</v-icon>
        {{InputData.name}}

    </v-card-title>
    <div class="d-flex flex-nowrap justify-space-between">
      
      <div style="width:50%;">
        <v-card-text style="margin-bottom: 15px; margin-left: 15px;">
          <v-row>
            
            <v-col cols=6>
              <p class="subtitle-2 text-left">
                <v-badge color="red lighten-2" :content="$t('ModalCard.type')" x-small overlap>
                  <v-chip color="#15336d" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-beaker</v-icon>
                    </v-avatar>
                    <b style="color:white;"
                    >{{type_descr}}</b>
                  </v-chip>
                </v-badge>
              </p>
              <p class="subtitle-2 text-left">
                <v-badge color="red lighten-2" :content="$t('ModalCard.station')" x-small overlap>
                  <v-chip color="#15336d" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-google-circles</v-icon>
                    </v-avatar>
                    <b style="color:white;">{{station_descr}}</b>
                  
                  </v-chip>
                </v-badge>
              </p>
              <p class="subtitle-2 text-left">
                <v-badge color="red lighten-2" :content="$t('ModalCard.exp_resp')" x-small overlap>
                  <v-chip :color="$mainColor" text-color="white">
                    <b style="color:white;">
                      {{responsibles_text}}
                    </b>
                  </v-chip>
                </v-badge>
                <v-icon
                  v-if="can_edit_dates"
                  small
                  style="margin-left: 60px;"
                  @click="set_resp_dialog()">
                  mdi-account-reactivate
                </v-icon>

              </p>
              <p class="subtitle-2 text-left" v-if='InputData.type==2 || InputData.type == 5'>
                <v-badge color="red lighten-2" :content="'Пучковое время'" x-small overlap>
                  <v-chip color="#15336d" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-google-circles</v-icon>
                    </v-avatar>
                    <b style="color:white;">{{provided_experiment_duration}}</b>
                  
                  </v-chip>
                </v-badge>
              </p>
            </v-col>
          </v-row>
          
          <v-card>
            <v-card-title>
              <b>
                <v-icon>mdi-clipboard-text</v-icon>
               Описание
              </b>
            </v-card-title>
            <v-card-text v-if='InputData.type==2 || InputData.type == 5'>{{InputData.source.proposal_name}}</v-card-text>
            <v-card-text v-else>{{InputData.source.experiment_comments}}</v-card-text>
          </v-card>
          <v-card-title v-if='InputData.type==2 || InputData.type == 5'>
            <div class="my-2">
              <v-btn 
              outlined 
              class='mt-4'
              @click="show_proposal()"
                color="#15336d">Подробнее</v-btn>
            </div>
          </v-card-title>

          <v-card-title v-if='InputData.type==2 || InputData.type == 5'>
            <v-chip color="#15336d" text-color="white" label>
              <v-icon left>mdi-plus-network</v-icon>
              Всего экспериментов по заявке ({{proposal_calendar.length}})
            </v-chip>
          </v-card-title>
          <v-timeline :dense="true" x-small v-if='InputData.type==2 || InputData.type == 5'>
            <template>
              <v-timeline-item
                x-small
                color="grey"
                v-for="(item, keys, index) in proposal_calendar"
                :key="index"
              >
                <template v-if='item.id===InputData.id' >
                  <strong style="color:#15336D">Текущий </strong>
                  <v-chip color="#15336D" text-color="white">
                    <v-icon left>mdi-calendar-today</v-icon>
                    {{formate_datetime(item.start_date)}} - {{formate_datetime(item.finish_date)}}
                  </v-chip>
                </template>
                <template  v-else>
                  <v-chip color="grey" text-color="white">
                    <v-icon left>mdi-calendar-today</v-icon>
                    {{formate_datetime(item.start_date)}} - {{formate_datetime(item.finish_date)}}
                  </v-chip>
                </template>

              </v-timeline-item>
            </template>
          </v-timeline>
  
          <v-spacer></v-spacer>
          <div></div>
          
          <v-card v-if='(InputData.type != 2 && InputData.type != 5) && InputData.source.is_completed' style="margin-top: 10px;">
            <v-card-title>
              <b>
                <v-icon>mdi-clipboard-text</v-icon>
                {{$t('comment')}}
              </b>
            </v-card-title>
            <v-card-text>{{InputData.source.comments}}</v-card-text>
          </v-card>

          <div v-if='(InputData.type != 2 && InputData.type != 5) && !InputData.source.is_completed' style="margin-top: 10px;">
            <v-textarea
                v-model="close_comment"
                solo
                name="input-7-4"
                label="Комментарий"
                outlined
                :maxlength="1000"
                counter
            ></v-textarea>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div>
                  <v-btn 
                    color="green darken-1" 
                    text 
                    :disabled="close_comment.length === 0" 
                    @click="closeRecord()"
                    :loading="loaded"
                  >Отметить выполненным</v-btn>
                </div>
              </v-card-actions>
          </div>
        </v-card-text>
      </div>

      <div style="margin-left: 10px; width:45%;" class="suggested pr-10">        
        <div>
          <set-date-intervals
              @updateParent="update_parent($event)" 
              :proposal_id="InputData.source.proposal_id"
              :station_id="InputData.source.station_id"
              :can_edit="can_edit_dates"
              :input_dates ="dates"
              :interval_multiple="false"
              :availiable_limit="availiable_limit"
              :calendar_id="InputData.id"
              :add_new="false"
              :small_view="false"
              :calendar_type="InputData.type"
          />
        </div>

        <v-list-item v-for="file in attached_files" :key="file.id" v-if="file.actions.can_see">
          <v-list-item-avatar>
            <v-icon left  @click="openFile(file)">mdi-file</v-icon>
          </v-list-item-avatar>
          <v-list-item-content   style="cursor: pointer;" @click="openFile(file)">
            <v-list-item-title v-text="file.name">
            </v-list-item-title>
            <v-list-item-subtitle v-text="g.toDate(file.add_date)"/>
          </v-list-item-content>
          <v-list-item-action>
            <!-- <v-btn @click="openFile(file)" icon>
              <v-icon color="grey lighten-1">mdi-download</v-icon>
            </v-btn> -->
            <v-btn x-small @click="deleteFile(file)" icon v-if="file.actions.buttons.delete">
              <v-icon color="red lighten-1">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-file-input
          v-model="file"
          label="Добавить файл ( < 6 мб, .doc, .docx, .pdf, .jpg)"
          color="#15336d"
          :success="loadedFile"
          :loading="loadedFile"
          prepend-icon="mdi-paperclip">
        </v-file-input>
      
      </div>
    </div>

    <v-dialog v-model="resp_dialog" persistent max-width="480">
      <v-card>
        <v-card-title class="headline">Укажите оператора эксперимента</v-card-title>

        <v-container fluid>
          <v-row align="center">
            <v-col
              class="d-flex"
              cols="12"
              sm="8"
            >
              <v-select
                v-model="Resps"
                :items="listResps"
                item-text="name"
                item-value="id"
                outlined
                chips
                required
                multiple
              ></v-select>
            </v-col>

          </v-row>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small  @click="resp_dialog = false">{{$t('cancel')}}</v-btn>
          <v-btn small  @click="update_resp()">{{$t("Actions.save")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>

</template>
<script>
import { mapGetters,mapActions, mapMutations } from 'vuex'
import setDateIntervals from "../../Proposals/setDateIntervals.vue";
import { DOMEN } from '../../../../vars.js';

export default {
  name: "calendarCard",
  props: {
    InputData: Object,
  },
  components: {
    setDateIntervals
  },
  
  data() {
    return {
      call_id: null,
      proposal_calendar: [],
      dates: [],
      resp_dialog: false,
      listResps: [],
      Resps: [],
      responsibles_text: '',
      availiable_limit: 720,
      can_edit_dates: false,
      close_comment: '',
      loaded: false,

      loadedFile: false,
      file: null,
      checkFile: false,
      file_id: null,
      attached_files: [],
    };
  },
  methods: {
    ...mapActions([
      'GET_FILES_LIST',
      'GET_PROPOSAL_LIST',
      'UPDATE_EXP_RESPONSIBLES',
      'UPDATE_CALENDAR_REC',
      'GET_INHOUSE_LIST',
      'FILE_SEND',
      'DELETE_FILE_SYNC',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
      'SHOW_PROPOSAL_CARD',
    ]),

    prepare_data(){
        this.dates = [
          this.formate_date(this.InputData.source.start_date),
          this.formate_date(this.InputData.source.finish_date),
        ]
        this.close_comment = ''

        this.load_attached_files()

        this.can_edit_dates = false
        if(this.InputData.type == 2 || this.InputData.type == 5){
          this.load_proposal_calendars()
          if(this.InputData.source.status_id == 5)
            this.can_edit_dates = true
        }
        else{
          this.availiable_limit = 720;
          this.can_edit_dates = this.InputData.source.is_completed ? false : true;
        }

      var add = false;
      this.listResps = [];
      var all = this.GETTERS_BS_LIST;
      var name = '';

      Object.entries(all).forEach(([key, user]) => {
        add = false;
        user.station_ids.forEach(cur => {
          if(cur == this.InputData.source.station_id)
            add = true;
        });
        if(add){
          name = user.last_name + ' ' + user.first_name[0] + '.'  + user.middle_name[0] + '.'
          this.listResps.push({name: name, id: user.id});
        }
      });

      this.update_responsibles_view()
    },

    load_attached_files(){
      this.GET_FILES_LIST({object_id:this.InputData.id, type: 6})
      .then((res) => {
        this.attached_files = res
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
      });
    },


    openFile(file) {
      if(file.actions.buttons.download)
        window.open(DOMEN + `/media/${file.name}`, '_blank')
    },

    deleteFile(file){
      this.DELETE_FILE_SYNC(file.id)
      .then(res => {
        if (res.status === 200) {
          this.load_attached_files()
        }
      })
      .catch(e => {
        console.log('e',e)
      })

    },

    load_proposal_calendars(){
      this.GET_PROPOSAL_LIST({proposal_id:this.InputData.source.proposal_id})
      .then((res) => {
        this.proposal_calendar = res;

        if(this.InputData.source.provided_experiment_duration > 0){
          var reserved_time = 0;
          var start_date, end_date, diff;
          this.proposal_calendar.forEach(item => {
            if(item.id != this.InputData.id){
              start_date = new Date(item.start_date);
              end_date = new Date(item.finish_date);
              diff = (end_date - start_date)/ 3600000;
              reserved_time += diff;
            }
          });
          this.availiable_limit = this.InputData.source.provided_experiment_duration - reserved_time;
        }
        else
          this.availiable_limit = 720;
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
      });
    },

    formate_datetime(str){
      var date_obj = new Date(str)
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate() 
      var m = date_obj.getMinutes()
      var h = date_obj.getHours()
      if (h<10) h = '0'+h
      if (m<10) m = '0'+m
      if (month<10) month = '0' + month
      if (date<10) date = '0' + date

      return date + '.' + month + '.' + date_obj.getFullYear() + ' ' + h + ':' + m
    },

    formate_date(str){
      var date_obj = new Date(str)
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate() 
      var m = date_obj.getMinutes()
      var h = date_obj.getHours()
      if (h<10) h = '0'+h
      if (m<10) m = '0'+m
      if (month<10) month = '0' + month
      if (date<10) date = '0' + date

      return date_obj.getFullYear() + '-' + month + '-' + date + ' ' + h + ':' + m
    },

    show_proposal() {
      this.call_id = new Date()
      this.SHOW_PROPOSAL_CARD({
        'proposal_id' : this.InputData.source.proposal_id,
        'call_id': this.call_id
      })
    },
    
    
    set_resp_dialog(){
      this.resp_dialog = true;
      this.Resps = this.InputData.source.resp;
    },

    update_resp(){
      var data = {
        'responsibles' : this.Resps,
        'id': this.InputData.id
      };
      this.UPDATE_EXP_RESPONSIBLES(data)
      .then(res => {
        if(res.status == true){
          this.resp_dialog = false;
          this.InputData.source.resp = res.responsibles;
        }
        else{
          this.$messageHelper('Что-то пошло не так... Попробуйте обновить страницу.', 'error', 4000);
        }
      })
    },

    update_responsibles_view(){
      if(this.InputData.source.resp !== null && this.InputData.source.resp.length > 0){
        var t = '',user = null
        this.InputData.source.resp.forEach(element => {
          user = this.GETTERS_BS_BY_ID(element)
          t = t + user.last_name + ' ' + user.first_name[0] + '.'  + user.middle_name[0] + '. '
        });
        this.responsibles_text = t
      }
      else
        this.responsibles_text = 'Отсутствует'
    },

    closeRecord(args){
      if(this.close_comment.length < 2){
        this.$messageHelper('Оставьте комментарий', 'error', 3000);
      }
      else{
        this.loaded = true

        this.UPDATE_CALENDAR_REC({
          id: this.InputData.id, 
          close_record: true,
          comments: this.close_comment
        })
        .then(res => {
          if(this.InputData.type == 0 || this.InputData.type == 1){
            this.GET_INHOUSE_LIST({station_id:this.InputData.source.station_id})        
          }
            this.loaded = false
            this.$emit('updateParent')
            this.$emit('closeModal')
        })
        .catch(() => {
            this.loaded = false
        })
      }

    },

    update_parent() {
      if(this.InputData.type == 2 || this.InputData.type == 5){
          this.load_proposal_calendars()
      }
      else{
        this.GET_INHOUSE_LIST({station_id:this.InputData.source.station_id})        
      }
      this.$emit('updateParent')
    },

    validateFile(val) {
      const type = val.name.split('.').pop();

      if (type === 'doc' ||
          type === 'docx' ||
          type === 'pdf' ||
          type === 'jpg' ||
          type === 'png' ||
          type === 'pptx' ||
          type === 'ppt') {
        if (val.size <= 6291456) {
            this.checkFile =  true
            this.saveFile()
        } else {
          this.$messageHelper(this.$t('Step2.6md'), 'error')
          this.checkFile = false
          this.file = null

        }
      } else {
        this.$messageHelper(this.$t('Step2.file_format_prohibited'), 'error')
        this.checkFile = false
        this.file = null
      }
    },

    saveFile() {
      if(this.checkFile) {
        this.loadedFile = true
        const files = new FormData();
        files.append('file', this.file);
        files.append('object_id', this.InputData.id)
        files.append('type', 6) // calendar

        this.FILE_SEND(files)
          .then((res) => {
            this.file = null
            this.loadedFile = false
            this.load_attached_files()
          })
          .catch(() => this.loadedFile = false)
      }
    },

  },

  computed: {
    ...mapGetters([
      'GETTERS_STATION_BY_ID',
      'GETTERS_CALENDAR_INIT',
      'GETTERS_BS_BY_ID',
      'GETTERS_BS_LIST',
      'GETTERS_NEED_RELOAD_CALENDAR',
      'GETTERS_NEED_RELOAD_CLOSE_PROPOSAL',
    ]),

    type_descr(){
      if(this.InputData.type == 0)
        return this.$t('station_maintenance')
      else if(this.InputData.type == 1)
        return 'in-house'
      else if(this.InputData.type == 2)
        return this.$t('proposal')
      else if(this.InputData.type == 5)
        return 'Заявка (черновик)'
      else if(this.InputData.type == 3)
        return 'sinchrotron disabled'
      else
        return ''
    },

    station_descr(){
      return this.GETTERS_CALENDAR_INIT ? this.GETTERS_STATION_BY_ID(this.InputData.source.station_id).name : ''
    },

    provided_experiment_duration(){
      if(this.InputData.source.provided_experiment_duration > 0)
        return 'Предоставлено : ' + this.InputData.source.provided_experiment_duration + ' ч.';
      else
          return 'Не задано';
    },
  },

  watch: {
    InputData:{
      handler: function (val, oldVal) { 
        this.prepare_data()
      },
      deep: true
    },

    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val)
      }
    },

    GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(val){
      if(val && val == this.call_id){
        this.update_parent()
      }
    },

    GETTERS_NEED_RELOAD_CALENDAR(val){
      if(val){
        this.update_parent()
      }
    },
    
  },
  
  beforeMount(){
    this.prepare_data()
  },
};
</script>

<style scoped>
.main-card {
  background-color: #f4f5f7 !important;
  border-radius: 2px;
  min-height: 700px;
}
.main-card * {
  color: #15336d;
}
.comment-expert,
.comment-bs {
  max-height: 40vh;
  overflow-y: auto;
}
</style>